import { render } from "./gooutmonad.vue?vue&type=template&id=6fbaba6a"
import script from "./gooutmonad.vue?vue&type=script&lang=js"
export * from "./gooutmonad.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__